import { useState, useEffect } from 'react';
import i18n from '../i18n';
import { isRTL } from '../constants/languages';

export function useDirection(): 'ltr' | 'rtl' {
  const [dir, setDir] = useState<'ltr' | 'rtl'>(() => (isRTL(i18n.language) ? 'rtl' : 'ltr'));

  useEffect(() => {
    const handler = (lng: string) => setDir(isRTL(lng) ? 'rtl' : 'ltr');
    i18n.on('languageChanged', handler);
    return () => {
      i18n.off('languageChanged', handler);
    };
  }, []);

  return dir;
}
